import type { BigNumber } from '@ethersproject/bignumber';
import type { LiquidityStrategyDepositToken } from '@ui/utils/strategy';
import { resetWhenRouterChange } from '@ui/utils/zustandMiddleware';
import { create } from 'zustand';

import { LiquidityStrategyStep } from './utils';

export type UseDepositDrawerStore = {
  isOpen: boolean;
  onOpen: (options: {
    amountStr: string;
    isWithdraw: boolean;
    token: LiquidityStrategyDepositToken;
  }) => void;
  onClose: () => void;
  step: LiquidityStrategyStep;
  isWithdraw: boolean;
  amountStr: string;
  token: LiquidityStrategyDepositToken;
  pendingNSteps: number;
  pendingCurrentStep: number;
  errorCode: string;
  errorMessage: string;
  receivedAmount: BigNumber | undefined;
};

export const useDepositDrawer = create(
  resetWhenRouterChange<UseDepositDrawerStore>((set) => ({
    isOpen: false,
    onOpen: ({ amountStr, isWithdraw, token }) => {
      set({
        isOpen: true,
        amountStr,
        isWithdraw,
        token,
      });
    },
    onClose: () => {
      useDepositDrawer.getState().$$resetData?.();
    },
    isWithdraw: false,
    step: LiquidityStrategyStep.default,
    amountStr: '',
    token: 'wcro',
    pendingNSteps: 1,
    pendingCurrentStep: 1,
    errorCode: '',
    errorMessage: '',
    receivedAmount: undefined,
  })),
);
